import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/theme/liga-logo-white.png'


const _hoisted_1 = { class: "ion-text-center white-regular username" }
const _hoisted_2 = { class: "account-info ion-margin-top" }
const _hoisted_3 = { class: "account-item" }
const _hoisted_4 = { class: "account-item-value dark-regular" }
const _hoisted_5 = { class: "account-item" }
const _hoisted_6 = { class: "account-item-value dark-regular" }
const _hoisted_7 = { class: "account-item account-item-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass('main-background'),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "logo" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "liga-logo"
            })
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "ion-text-center white-bold" }, "ЛИЧНЫЙ КАБИНЕТ", -1)),
          _createVNode(_component_ion_avatar, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadAvatar()))
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.cameraOutline }, null, 8, ["icon"]), [
                [_vShow, _ctx.avatarUrl.length < 1]
              ]),
              _withDirectives(_createVNode(_component_ion_img, { src: _ctx.avatarUrl }, null, 8, ["src"]), [
                [_vShow, _ctx.avatarUrl.length > 1]
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.lastname) + " " + _toDisplayString(_ctx.firstname), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "account-item-label dark-bold" }, "Логин", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.username), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "account-item-label dark-bold" }, "E-mail", -1)),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.email), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "account-item-label dark-bold" }, "Пароль", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "account-item-value dark-regular" }, "******", -1)),
              _createVNode(_component_ion_icon, {
                icon: _ctx.keyOutline,
                class: "password-icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePassword()))
              }, null, 8, ["icon"])
            ]),
            _createVNode(_component_ion_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signOut()))
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Выход", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}